<template>
  <div>
    <!-- 🔶 Barra superior fija -->
    <div class="top-bar">
      <div class="info-contacto">
        <v-icon left small>mdi-phone</v-icon>
        +51928180748

        <v-icon left small class="ml-4">mdi-email</v-icon>
        informes@consultora-innova.com

        <v-icon left small class="ml-4">mdi-clock-outline</v-icon>
        Lun - Sáb: 8:00 - 8:00pm
      </div>

      <div class="redes">
        <v-btn icon class="white--text"><v-icon small>mdi-facebook</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-linkedin</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-youtube</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-skype</v-icon></v-btn>

        <v-btn text class="white--text text-caption font-weight-bold ml-2">
          <v-icon left small>mdi-account</v-icon>
          INGRESAR
        </v-btn>
      </div>
    </div>

    <!-- 🔳 Menú principal -->
    <v-app-bar color="white" dense elevate-on-scroll class="main-bar" app>
      <v-toolbar-title>
        <router-link to="/">
          <v-img
            :src="require('@/assets/consultora_innova_ag_logo_horizontal_v2.svg')"
            alt="Consultora Innova"
            contain
            height="50"
            max-width="250"
          />
        </router-link>
      </v-toolbar-title>

      <v-spacer />

      <!-- Menú escritorio -->
      <v-row class="d-none d-md-flex" align="center">
        <template v-for="(item, index) in menuItems">
          <!-- Ítem normal -->
          <v-btn
            v-if="!item.isDropdown"
            :key="'menu-' + index"
            text
            :to="item.link"
            exact
            :class="{ 'active-item': isActive(item.link) }"
          >
            {{ item.title }}
          </v-btn>

          <!-- Dropdown con submenú -->
          <v-menu
            v-else
            :key="'dropdown-' + index"
            offset-y
            nudge-bottom="8"
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                :class="{ 'active-item': isDropdownActive(item.items) }"
              >
                {{ item.title }}
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-for="(subItem, subIndex) in item.items"
                :key="'sub-' + subIndex"
                :to="subItem.link"
              >
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-row>

      <!-- Botón hamburguesa móvil -->
      <div class="d-flex d-md-none">
        <v-app-bar-nav-icon @click="drawer = true" />
      </div>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer v-model="drawer" app temporary left width="280">
      <div class="drawer-header">
        <router-link to="/" @click.native="drawer = false">
          <v-img
            :src="require('@/assets/consultora_innova_ag_logo_horizontal_v2.svg')"
            alt="Logo"
            contain
            height="45"
            max-width="180"
          />
        </router-link>
        <v-btn icon @click="drawer = false" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-list dense nav>
        <template v-for="(item, index) in menuItems">
          <!-- Ítem normal -->
          <v-list-item
            v-if="!item.isDropdown"
            :key="'drawer-item-' + index"
            :to="item.link"
            router
            @click="drawer = false"
          >
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Submenú móvil expansible -->
          <v-list-group
            v-else
            :key="'drawer-group-' + index"
            :value="false"
            prepend-icon="mdi-folder-multiple"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="(subItem, subIndex) in item.items"
              :key="'drawer-sub-' + subIndex"
              :to="subItem.link"
              @click="drawer = false"
            >
              <v-list-item-icon>
                <v-icon>mdi-menu-right</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="ml-2">{{ subItem.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      drawer: false,
      menuItems: [
        { title: "Inicio", link: "/" },
        { title: "Cursos", link: "/cursos" },
        { title: "Nosotros", link: "/nosotros" },
        { title: "Blog", link: "/blog" },
        { title: "Contacto", link: "/contacto" },
        {
          title: "Recursos Tech",
          isDropdown: true,
          items: [
            { title: "Hosting para devs", link: "/recursos/hosting" },
            { title: "Herramientas SaaS", link: "/recursos/saas" },
            { title: "Ciberseguridad", link: "/recursos/ciberseguridad" },
            { title: "Seguros para devs", link: "/recursos/seguros-tech" },
            { title: "Comparativas", link: "/recursos/comparativas" },
          ],
        },
      ],
    };
  },
  methods: {
    isActive(link) {
      return this.$route.path === link;
    },
    isDropdownActive(items) {
      return items.some((item) => this.$route.path === item.link);
    },
  },
};
</script>

<style scoped>
/* Barra superior */
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 36px;
  background-color: #2191c5;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 3000;
  font-size: 13px;
}

.info-contacto {
  display: flex;
  align-items: center;
  gap: 12px;
}

.redes {
  display: flex;
  align-items: center;
}

/* Menú principal */
.main-bar {
  top: 36px !important;
  position: fixed !important;
  z-index: 2000 !important;
  width: 100%;
}

/* Ítem activo */
.active-item {
  background-color: #f5c9a0 !important;
  color: #d7641a !important;
  border-radius: 6px;
  font-weight: bold;
  padding: 6px 12px;
}

/* Drawer móvil */
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.close-btn {
  color: #d7641a;
}

/* Responsive */
@media (max-width: 600px) {
  .info-contacto {
    display: none !important;
  }
  .top-bar {
    justify-content: center !important;
  }
}
</style>
